module.exports = __webpack_public_path__ + "img/bla_play_button.9e1a2592.png";